// 组件对象，大写
import selectTemplateModal from './selectTemplateModal.vue'
export default selectTemplateModal
